export default String.raw`
.formal-content {
    margin: 16px 5%;

    .content {
        margin-bottom: 32px;

        &__header {
            display: flex;
            flex-direction: column;
            margin-top: 24px;
            margin-bottom: 24px;
        }
    }

    .files {
        margin-bottom: 24px;
    }

    &:not(:has(aside.files)) .content {
        margin-bottom: 24px;
    }
}
`